<template>
  <div class="footer">
    <div class="container">
      <div class="row">
        <div class="div_logo col-sm-6">
          <router-link class="lien_image" :to="{name:'Home'}">
            <img alt="logo" src="../assets/metzexpress.png" width="225px"/>
          </router-link>
        </div>
        <div class="col-sm-6 col_right">
          <p class="titre_footer">Contact</p>
          <div class="liens_footer">
            <ul>
              <li>
                <a class="telephone" href="tel:0387390812">03 87 39 08 12</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div id="copyright">
        <p>Copyright © 2020 Antoni Voyages</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    data () {
      return {}
    }
  }
</script>

<style scoped lang="scss">
  @import "../../node_modules/bootstrap/scss/bootstrap";
  @import "../sass/variables";

  .footer {
    color: $firstcolor;
    margin-top: 3rem;
    padding: 1rem;

    .titre_footer {
      text-transform: uppercase;
      font-family: $titlefont;
      font-weight: 900;
      font-size: 25px;
    }

    ul {
      padding: 0;
      list-style-type: none;
    }

    a {
      color: $firstcolor;
      font-weight: bold;
    }

    a:hover {
      color: $secondcolor;
      text-decoration: none;
    }

    .col_right {
      text-align: right;
      @include media-breakpoint-down(xs) {
        text-align: left;
        margin-top: 2rem;
      }
    }

    .liens_footer {
      display: grid;
    }

    .div_logo {
      @include media-breakpoint-down(xs) {
        display: flex;
        a {
          margin: auto;
        }
      }
    }

    #copyright {
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      margin-top: 2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue